export function addItemToState(item) {
    return function (state) {
        return Object.assign(Object.assign({}, state), { items: state.items.concat(item) });
    };
}
